import React from "react";
import { DoorOpenIcon, KeyRoundIcon, LockIcon, ShieldCheckIcon, WrenchIcon, BoxIcon } from "lucide-react";
import { services, Service } from "../data/services";
import { company } from "../data/company";
import { SectionHeading } from "./SectionHeading";
const icons: Record<Service['icon'], BoxIcon> = {
  key: KeyRoundIcon,
  lock: LockIcon,
  shield: ShieldCheckIcon,
  door: DoorOpenIcon,
  wrench: WrenchIcon
};
export function Services() {
  const featured = services.find(s => s.featured) ?? services[0];
  const others = services.filter(s => s !== featured);
  const FeaturedIcon = icons[featured.icon];
  return <section id="prestations" className="bg-bone py-16 lg:py-24" data-id="element-193" data-mp="u736xv4k4pxb">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-194" data-mp="q4q5vk0r9g6v">
        <SectionHeading title="Ce que je fais, et comment" intro="Cinq prestations, toutes réalisées par moi-même. Pas de sous-traitance, pas d’intermédiaire qui prend une commission sur votre facture." data-id="element-195" data-mp="q6ayv57f8r2m" />

        <div className="mt-12 grid gap-6 lg:grid-cols-[1.1fr_0.9fr]" data-id="element-196" data-mp="g8dbejxdyyb2">
          <article className="flex flex-col bg-ink-900 p-8 text-bone lg:p-10" data-id="element-197" data-mp="36bob50xyyied">
            <div className="flex items-center gap-3" data-id="element-198" data-mp="3b3fzr5xkee1v">
              <FeaturedIcon className="h-6 w-6 text-brass-light" aria-hidden="true" data-id="element-199" data-mp="3b50xt5j38f4h" />
              <span className="text-xs font-semibold uppercase tracking-[0.16em] text-brass-light" data-id="element-200" data-mp="2x9oqlynqww6o">
                Demande la plus fréquente
              </span>
            </div>
            <h3 className="mt-5 font-display text-2xl font-bold leading-tight lg:text-3xl" data-id="element-201" data-mp="3q0yoi8a8sr9b">
              {featured.title}
            </h3>
            <p className="mt-4 text-base leading-relaxed text-bone-dark" data-id="element-202" data-mp="3g29hjajvwr7u">{featured.description}</p>
            <ul className="mt-6 space-y-2.5 border-t border-ink-700 pt-6" data-id="element-203" data-mp="3l1dpjxv2oiwl">
              {featured.details.map(detail => <li key={detail} className="flex gap-3 text-sm text-ink-500" data-id="element-204" data-mp="24ndr6rbvl1bg">
                  <span className="mt-2 h-1 w-1 flex-none rounded-full bg-brass" aria-hidden="true" data-id="element-205" data-mp="24pgrc46qsatw" />
                  {detail}
                </li>)}
            </ul>
            <a href={company.phoneHref} className="mt-auto pt-8 font-display text-base font-bold text-brass-light underline decoration-brass/40 decoration-2 underline-offset-4 transition-colors duration-150 ease-out hover:text-bone" data-id="element-206" data-mp="1pisx6ekyn1kl">
              Décrire ma situation au {company.phone}
            </a>
          </article>

          <div className="grid gap-px bg-bone-dark" data-id="element-207" data-mp="1bqldnoiot73u">
            {others.map(service => {
            const Icon = icons[service.icon];
            return <article key={service.title} className="bg-bone px-1 py-6 first:pt-0 last:pb-0" data-id="element-208" data-mp="11u06oxn3xlxd">
                  <div className="flex gap-4" data-id="element-209" data-mp="xsen6tg2i9e7">
                    <Icon className="mt-1 h-5 w-5 flex-none text-brass" aria-hidden="true" data-id="element-210" data-mp="xt6i021uc33f" />
                    <div data-id="element-211" data-mp="svejgp6oxiq9">
                      <h3 className="font-display text-lg font-bold text-ink-900" data-id="element-212" data-mp="sw6d3ugq96dw">{service.title}</h3>
                      <p className="mt-2 text-sm leading-relaxed text-ink-600" data-id="element-213" data-mp="2n7uv65i99p2i">
                        {service.description}
                      </p>
                      <p className="mt-2 text-xs text-ink-500" data-id="element-214" data-mp="2uqkkochjwpaw">{service.details.join(' · ')}</p>
                    </div>
                  </div>
                </article>;
          })}
          </div>
        </div>
      </div>
    </section>;
}